import React, { FC, useEffect, useState } from "react";
import { useAppSelector } from "../../store";
import { getTournoi } from "../../features/tournoi/tournoiSlice";
import { normalizeGoogleMapsEmbedUrl } from "../../utils/normalizeGoogleMapsEmbedUrl";
import {
  Box,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
  Zoom,
} from "@mui/material";
import { AppInfoBanner } from "../Base/AppInfoBanner";

interface ContactUsProps {}

const ContactUs: FC<ContactUsProps> = () => {
  const tournoi = useAppSelector(getTournoi);
  const [iframeHeight, setIframeHeight] = useState(300);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px

  useEffect(() => {
    const updateHeight = () => {
      const toolbarHeight = 64;
      const padding = 24 * 2;
      const alertHeight = isMobile ? 130 : 120;
      const availableHeight =
        window.innerHeight - toolbarHeight - padding - alertHeight;
      setIframeHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [isMobile]);

  if (!tournoi) return null;

  const mapsEmbedSrc = normalizeGoogleMapsEmbedUrl(tournoi.maps ?? "");
  const mailto = `mailto:${tournoi.mail}`;

  return (
    <Zoom in>
      <Stack spacing={2}>
        <Box
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            animation: "fadeIn 0.5s ease-in-out",
            overflow: "hidden",
          }}
        >
          <AppInfoBanner>
            <Box sx={{ textAlign: "left" }}>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                component="div"
                sx={{
                  color: "inherit",
                  "& a": {
                    color: "inherit",
                    fontWeight: 600,
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                  },
                }}
              >
                Pour toute question concernant le tournoi, vous pouvez nous
                contacter à l&apos;adresse{" "}
                <a href={mailto}>{tournoi.mail}</a>
              </Typography>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                component="div"
                sx={{ mt: 1.5, color: "inherit" }}
              >
                Le tournoi se déroulera à {tournoi.adresse}.
              </Typography>
            </Box>
          </AppInfoBanner>
        </Box>

        {/* Map Embed */}
        <Box
          sx={{
            width: "100%",
            height: iframeHeight,
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 2,
            animation: "fadeIn 0.5s ease-in-out",
          }}
        >
          {mapsEmbedSrc ? (
            <iframe
              title={tournoi.mapsTitle || "Carte du lieu"}
              src={mapsEmbedSrc}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          ) : null}
        </Box>
      </Stack>
    </Zoom>
  );
};

export default ContactUs;
